import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
var _excluded = ["mutateAsync"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from 'utils/api';
import { userProfileQueryKeys } from 'actions/userProfile';
import userSettingsKeys from './queryKeys';
function updateUserSettings(_x) {
  return _updateUserSettings.apply(this, arguments);
}
function _updateUserSettings() {
  _updateUserSettings = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(settings) {
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", api('patch', '/api/me/settings', null, settings));
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _updateUserSettings.apply(this, arguments);
}
function useUpdateMyUserSettings() {
  var queryClient = useQueryClient();
  var _useMutation = useMutation({
      mutationFn: updateUserSettings,
      onSuccess: function onSuccess(response, changes) {
        queryClient.setQueryData(userSettingsKeys.userSettings, function (settings) {
          return _objectSpread(_objectSpread({}, settings), changes);
        });
        queryClient.setQueryData(userProfileQueryKeys.userProfile, function (profile) {
          return _objectSpread(_objectSpread({}, profile), {}, {
            settings: _objectSpread(_objectSpread({}, profile.settings), changes)
          });
        });
        queryClient.invalidateQueries({
          queryKey: userSettingsKeys.userSettings
        });
        queryClient.invalidateQueries({
          queryKey: userProfileQueryKeys.userProfile
        });
      }
    }),
    mutateAsync = _useMutation.mutateAsync,
    result = _objectWithoutProperties(_useMutation, _excluded);
  return _objectSpread(_objectSpread({}, result), {}, {
    updateUserSettings: mutateAsync
  });
}
export default useUpdateMyUserSettings;